import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders, HttpEvent } from '@angular/common/http';
import { UtilDadosLogado } from '../servicos/util.logado';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class UploadService {
  constructor(private http: HttpClient, private utilDadosLogado: UtilDadosLogado) {}

  public Uploads(metodo: string, files: Set<File>, formData: FormData): { [key: string]: Observable<number> } {
    const status = {};

    files.forEach(file => {
      formData.append('DADOS', file, file.name);

      // let dados = JSON.parse(localStorage.getItem('DadosAcesso'));

      // let headers = new HttpHeaders();

      // if (dados && dados.token) {
      //   headers = headers.set('Authorization', 'Bearer ' + dados.token);
      // }

      let headers = new HttpHeaders();

      if (this.utilDadosLogado.DadosAcesso().token) {
        headers = headers.set('Authorization', 'Bearer ' + this.utilDadosLogado.DadosAcesso().token);
      }

      const req = new HttpRequest('POST', `${this.utilDadosLogado.DadosAcesso().url}/api/${metodo}`, formData, {
        headers: headers,
        reportProgress: true
      });

      const progress = new Subject<number>();

      this.http.request(req).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round((100 * event.loaded) / event.total);

          progress.next(percentDone);
        } else if (event instanceof HttpResponse) {
          progress.complete();
        }
      });

      status[file.name] = {
        progress: progress.asObservable()
      };

      formData.delete('DADOS');
    });

    return status;
  }

  public Upload(metodo: string, formData: FormData): Observable<HttpEvent<any>> {
    let headers = new HttpHeaders();

    if (this.utilDadosLogado.DadosAcesso().token) {
      headers = headers.set('Authorization', 'Bearer ' + this.utilDadosLogado.DadosAcesso().token);
    }

    const options = {
      headers: headers,
      reportProgress: true
    };

    const req = new HttpRequest('POST', `${this.utilDadosLogado.DadosAcesso().url}/api/${metodo}`, formData, options);

    return this.http.request(req);
  }
}
